import { CLEAR_TEMPORARY_SETTINGS, CREATE_SETTING_COLOR_SCHEME, DELETE_SCHEME_SETTING, LOAD_TAB_SETTINGS, RESET_SCHEME_SETTINGS, SET_COLOR_PRIMARY_COLUMN } from "store/constans"
import { ColorSidebarService } from "utils/services/colorSidebar.service"

export const loadTabSettingsAC = ({currentTableId, colorScheme, columnSchemes}) => {
    return ({
        type: LOAD_TAB_SETTINGS,
        payload: {
            currentTableId,
            colorScheme: colorScheme,
            columnSchemes: columnSchemes,
        }
    })
}
export const clearTemporarySettingsAC = () => {
    return ({
        type: CLEAR_TEMPORARY_SETTINGS
    })
}

export const setPrimaryColorAC = (currentColumnId, currentTableId) => {
  return {
    type: SET_COLOR_PRIMARY_COLUMN,
    payload: {
      currentColumnId,
      currentTableId,
    },
  };
};

export const deleteSettingColorSchemeAC = (columnName, currentTableId) => {
  return ({
    type: DELETE_SCHEME_SETTING,
    payload: {
      columnName,
      currentTableId
    }
  })
}

export const resetSettingSchemeAC = () => {
  return ({
    type: RESET_SCHEME_SETTINGS,
  })
}

export const createSettingColorSchemeAC = ({currentTableId, columnId ,...schemeData}) => {

    const colorScheme = ColorSidebarService.createColorScheme(schemeData)

    const uniqueColorsData = {
        store: {},
        positionObj: {
          horizontalIndex: null,
          verticalIndex: null,
        },
    }
  
    return {
      type: CREATE_SETTING_COLOR_SCHEME,
      payload: {
        columnId,
        currentTableId,
        colorScheme,
        uniqueColorsData,
      },
    };
  };